import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnChanges,
    OnInit,
    Renderer2,
    SimpleChanges,
} from "@angular/core";
import { FeedbackBlockIcons, FeedbackBlockKind } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-feedback-block",
    templateUrl: "./sps-feedback-block.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsFeedbackBlockComponent implements OnInit, OnChanges {
    static readonly displayName = "sps-feedback-block";
    static readonly props = {
        kind: "FeedbackBlockKind",
    };

    @Input() kind: FeedbackBlockKind = FeedbackBlockKind.INFO;

    @HostBinding("class.sps-feedback-block") readonly _spsFeedbackBlockClass = true;
    @HostBinding("attr.role") readonly _role = "alert";

    _icon: string;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit() {
        this._icon = FeedbackBlockIcons[this.kind];
        this.renderer.addClass(this.elementRef.nativeElement, `sps-feedback-block--${this.kind}`);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.kind) {
            this._icon = FeedbackBlockIcons[this.kind];
            this.renderer.removeClass(this.elementRef.nativeElement, `sps-feedback-block--${changes.kind.previousValue}`);
            this.renderer.addClass(this.elementRef.nativeElement, `sps-feedback-block--${changes.kind.currentValue}`);
        }
    }
}
